import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { navLinks } from "../mock";
import { Menu, X } from "lucide-react";
import { track } from "../lib/analytics";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#f7f3ea]/85 backdrop-blur-md border-b border-[#e9e0cd]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1 group">
          <span className="font-display text-[22px] font-semibold tracking-tight text-[#0f1724]">
            ascend
          </span>
          <span className="font-display text-[22px] font-semibold tracking-tight text-[#486a8f] group-hover:text-[#3a5a7c] transition-colors">
            higher
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors link-underline"
            >
              {l.label}
            </a>
          ))}
          <Link to="/challenge" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors link-underline">
            Challenge
          </Link>
          <Link to="/faq" className="font-body text-[14px] text-[#2b3442] hover:text-[#486a8f] transition-colors link-underline">
            FAQ
          </Link>
          <Link to="/start" onClick={() => track("nav_login_click")}
            className="font-body text-[14px] text-[#486a8f] hover:text-[#3a5a7c] transition-colors link-underline">
            Log In
          </Link>
          <Link to="/start" onClick={() => track("nav_start_free_click")}>
            <Button data-testid="nav-start-free-btn" className="h-10 px-5 rounded-full bg-[#486a8f] hover:bg-[#3a5a7c] text-white font-medium text-[14px] btn-lift">
              Try Ascend Higher
            </Button>
          </Link>
        </nav>

        <button
          className="md:hidden text-[#0f1724]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#f7f3ea] border-t border-[#e9e0cd] px-6 py-6 space-y-4">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-body text-[15px] text-[#2b3442]"
            >
              {l.label}
            </a>
          ))}
          <Link to="/faq" onClick={() => setOpen(false)} className="block font-body text-[15px] text-[#2b3442]">
            FAQ
          </Link>
          <Link to="/start" onClick={() => setOpen(false)} className="block font-body text-[15px] text-[#486a8f]">
            Log In
          </Link>
          <Link to="/start" onClick={() => setOpen(false)}>
            <Button className="w-full h-11 rounded-full bg-[#486a8f] hover:bg-[#3a5a7c] text-white">
              Try Ascend Higher
            </Button>
          </Link>
        </div>
      )}
    </header>
  );
}
